module.exports = {"330108001":"西兴街道","330108002":"长河街道","330108003":"浦沿街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330108.json
// module id = 1046
// module chunks = 0